import { CurrencyAccount } from "./currency_account";

export class ContainmentAccount extends CurrencyAccount {
    bankName: string;
    bankInfoId: string
}
